import { nucleusConstants, recordingActions } from '@lifesize/nucleus';
import { PayloadAction } from '@lifesize/typescript-react-redux-utils';
import actions, { RecordingsActionType } from 'actions/recordingsActions';
import {
  RecordingLimits,
  RecordingRequestObjectFeed,
  RecordingRequestObjectSort,
  RecordingRequestObjectTimeLine,
  UNKNOWN_MEETING_NAME
} from 'constants/recordingsConstants';
import { RecordingRequest } from 'interfaces/RecordingRequest';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { selectPageNumber } from 'selectors/paginationSelectors';
import RecordingsState from 'state/Recordings';
import { getNowFormattedString } from 'utils/date-time-utils';
import _get from 'lodash/get';

const generateRequestObject =
  (feedName: RecordingRequestObjectFeed,
   pageNum: number,
   sortBy: RecordingRequestObjectSort,
   timeline: RecordingRequestObjectTimeLine,
   limit: number): RecordingRequest => {
    return {
      feed: feedName,
      page: pageNum,
      sort: sortBy,
      timeline: timeline,
      offset: (pageNum - 1) * limit,
      limit: limit,
      timestamp: getNowFormattedString()
    };
  };

/**
 * Returns RecordingRequestObject to pass to Nucleus API.
 * Optional overrides can be provided to use values other than defaults
 * @param {RecordingsActionType} actionType
 * @param {RecordingsState | null} overrides
 * @return {RecordingRequestObject}
 */
const getPostRequestForType = (pageNumber: number,
                               overrides?: RecordingsState | null,
                               feedType?: RecordingRequestObjectFeed): RecordingRequest => {
  let requestObject: RecordingRequest;
  // Defaults if no overrides
  const feed = feedType ? feedType : RecordingRequestObjectFeed.FEED_ALL;
  const pageNum = pageNumber;
  const sortBy = overrides ? overrides.sortBy : RecordingRequestObjectSort.SORT_DATE;
  const timeLine = overrides ? overrides.timeline : RecordingRequestObjectTimeLine.TIMELINE_ANY;
  const meeting = _get(overrides, 'meeting');

  requestObject = generateRequestObject(
    feed,
    pageNum,
    sortBy,
    timeLine,
    RecordingLimits.RECORDINGS_FEED
  );

  if (meeting) {
    requestObject.meeting = meeting;
  }

  return requestObject;
};

const recordingsDataLoadMiddleware =
  (store: MiddlewareAPI) =>
    (next: Dispatch) => {
      return (action: PayloadAction<string, RecordingRequestObjectFeed>) => {
        if (action.type === RecordingsActionType.RECORDINGS_LOAD_RECORDS) {
          const myState = store.getState();
          const recordingsObject = (myState.app) ? myState.app.get('recordings', null) : null;
          const pageNumber = (selectPageNumber(myState) || 0) + 1;
          const requestObject = getPostRequestForType(pageNumber, recordingsObject, action.payload);
          return next(recordingActions.fetchFeed(requestObject));
        }
        if (action.type === nucleusConstants.RECORDINGS_FETCH_FEED_SUCCESS) {
          let meetingName = _get(action, 'payload.selected_meeting.name', '');
          if (meetingName === UNKNOWN_MEETING_NAME) { meetingName = ''; }
          actions.setRecordingSearchName(meetingName);
        }
        return next(action);
      };
    };

export default (recordingsDataLoadMiddleware as Middleware);
